import colors from "../base/colors";
import typography from "../base/typography";
import borders from "../base/borders";

import pxToRem from "../functions/pxToRem";

const { text, primary, grey, background } = colors;
const { size, fontWeightMedium, fontWeightBold } = typography;
const { borderRadius } = borders;

const toggleButton = {
  styleOverrides: {
    root: {
      color: grey[700],
      border: "none",
      backgroundColor: "transparent",
      textTransform: "none" as const,
      fontWeight: fontWeightMedium,
      fontSize: size.sm,
      padding: `${pxToRem(6)} ${pxToRem(12)}`,
      borderRadius: borderRadius.sm,
      transition: "background-color 140ms ease, color 140ms ease",

      "&:hover": {
        backgroundColor: background.tonal,
        color: text.primary,
      },

      "&.Mui-selected": {
        backgroundColor: primary.main,
        color: primary.contrastText,
        fontWeight: fontWeightBold,

        "&:hover": {
          backgroundColor: primary.dark,
          color: primary.contrastText,
        },
      },

      "&.Mui-disabled": {
        color: text.disabled,
        backgroundColor: "transparent",
      },
    },
  },
};

const toggleButtonGroup = {
  styleOverrides: {
    root: {
      backgroundColor: grey[100],
      border: `1px solid ${grey[300]}`,
      borderRadius: borderRadius.md,
      padding: pxToRem(3),
      gap: pxToRem(2),

      "& .MuiToggleButtonGroup-grouped": {
        border: "none !important",
        borderRadius: `${borderRadius.sm} !important`,
        marginLeft: "0 !important",
      },

      "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
        marginLeft: 0,
      },
    },
  },
};

export { toggleButton, toggleButtonGroup };
